import { render, staticRenderFns } from "./product_slider.vue?vue&type=template&id=0637b2fc&"
import script from "./product_slider.vue?vue&type=script&lang=js&"
export * from "./product_slider.vue?vue&type=script&lang=js&"
import style0 from "./product_slider.vue?vue&type=style&index=0&id=0637b2fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports